import React, { useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

const Terceirizadas = () => {
    const [dados, setDados] = useState({})
    const [empresas, setEmpresas] = useState([])

    const updateField = (e) => {
        const { name, value } = e.target
        let newState = { ...dados }
        newState[name] = value
        setDados(newState)
    }

    const send = () => {
        const url = '/api/tvs/buscaTerceirizados'
        axios.post(url, dados)
            .then(res => setEmpresas(res.data))
            .catch(error => alert(error.response.data))
    }

    const estilo = {
        principal: {
            display: "inline-grid", width: "20vw",
            textAlign: "left", color: "#484848", marginTop: "2vh"
        },
        input: {
            width: "20vw", backgroundColor: "#00000000", border: "1px solid #00000029", borderRadius: "5px",
            minHeight: "5px"
        },
        botao: {
            border: "none", backgroundColor: "#28a745", paddingTop: "5px", paddingBottom: "5px",
            paddingLeft: "12px", paddingRight: "12px", borderRadius: "15px", color: "#FFFF", marginTop: "5vh"
        }
    }

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between", width: "60vw", marginLeft: "20vw" }}>
                <div style={estilo.principal}>
                    <div>Filtro</div>
                    <select style={estilo.input} name="tipo" onChange={e => updateField(e)} >
                        <option value=""></option>
                        <option value="cnpj">CNPJ</option>
                        <option value="empresa">Empresa</option>
                        <option value="responsavelTecnico">Responsável Técnico</option>
                        <option value="numeroRegistro">Número de Registro</option>
                        <option value="endereco">Endereço</option>
                    </select>
                </div>
                <div style={estilo.principal}>
                    <div>Valor</div>
                    <input style={estilo.input} type="text" name="valor" onChange={e => updateField(e)} />
                </div>
            </div>
            <div>
                <button style={estilo.botao} onClick={e => send()}>Buscar</button>
            </div>
            <div className="container mx-auto">
                <div className="text-center mx-auto">
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>EMPRESA</th>
                                <th>PAF/TV</th>
                                <th>ESTABELECIMENTO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {empresas.length > 0 ? (
                                empresas.map(el => {
                                    return (
                                        <tr>
                                            <td>{el.empresa}</td>
                                            <td>{el.paf} / {el.tv}</td>
                                            <td>{el.estabelecimento}</td>
                                            <td>
                                                <Link to={`/documentosPaf/${el.pafId}`} target="_blank">
                                                    <button style={{
                                                        border: "none", backgroundColor: "#28a745", outline: "none",
                                                        height: "25px",
                                                        paddingLeft: "12px", paddingRight: "12px",
                                                        borderRadius: "15px", color: "#FFFF", marginRight: "1vw"
                                                    }}>Abrir</button>
                                                </Link>
                                            </td>
                                        </tr>)
                                }
                                )
                            ) : (<></>)}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default Terceirizadas